export default __webpack_public_path__ + "static/media/abcdropone.930e7b50.png";